import React from "react";

const TextAreaInput = ({
  name,
  id,
  label,
  ariaLabel = "",
  value,
  handleChange,
  placeholder,
  required = false,
  disabled,
  errorMessage,
  rows = 5,
  maxLength,
  cName,
  labelClassName,
  handleBlur,
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) => {
  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const ariaLabelText =
    ariaLabelProp ||
    ariaLabel ||
    (typeof label === "string" && label.trim() ? label.trim() : "") ||
    (typeof placeholder === "string" && placeholder.trim() ? placeholder.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "") ||
    "Text area";

  return (
    <div>
      {label && (
        <label
          htmlFor={id || name}
          className="form-label col-form-label w-100 fs-5 form-label-custom-visible"
        >
          {label} {isRequired && <span className="text-danger">*</span>}
        </label>
      )}
      <div>
        <textarea
          name={name}
          id={id || name}
          className={`form-control mb-5px fs-5 ${cName} ${
            errorMessage && errorMessage?.[name]?.trim()?.length > 0
              ? "input-error"
              : ""
          }`}
          value={value}
          // onFocus={() => setIsFocused(true)}
          // onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          aria-label={ariaLabelText}
          aria-required={isRequired}
          onChange={handleChange}
          // required={required}
          autoComplete="off"
          disabled={disabled}
          rows={rows}
          maxLength={maxLength}
          onBlur={handleBlur}
        />
        {errorMessage &&
          errorMessage[name] &&
          Object?.keys(errorMessage).length > 0 && (
            <div className={`text-danger fw-700 fs-6 mt-1 ${labelClassName}`}>
              {errorMessage && errorMessage[name] && errorMessage[name]}
            </div>
          )}
      </div>
    </div>
  );
};

export default TextAreaInput;
